import { render, staticRenderFns } from "./familyInfo.vue?vue&type=template&id=bd2db720&scoped=true&"
import script from "./familyInfo.vue?vue&type=script&lang=js&"
export * from "./familyInfo.vue?vue&type=script&lang=js&"
import style0 from "./familyInfo.vue?vue&type=style&index=0&id=bd2db720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2db720",
  null
  
)

export default component.exports